import OfficeFileViewer from './OfficeFileViewerContainer';
export default OfficeFileViewer;
